import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

function UpdateComplain() {
  const navigate = useNavigate();
  let { oid } = useParams();
  const server_url = localStorage.getItem("server_url");
  const dealer_id = localStorage.getItem("dealer_id");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [complain_dealer_review, setcomplain_dealer_review] = useState([]);
  const [complain_issued_quantity, setcomplain_issued_quantity] = useState([]);
  const [complain_supplied_quantity, setcomplain_supplied_quantity] = useState(
    []
  );
  const [complain_nature_of_issue, setcomplain_nature_of_issue] = useState([]);
  const [complain_issue_video, setcomplain_issue_video] = useState([]);
  const [complain_issue_image, setcomplain_issue_image] = useState([]);
  const [product_name, setProductName] = useState([]);
  const [order_title, setorder_title] = useState([]);

  const [show, setShow] = useState(true);
  const [quantity, setQuantity] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    get_complainDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const get_complainDetails = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("from", "");
      formData.append("to", "");
      formData.append("complain_id", oid);

      const { data } = await axios.post(`${server_url}complain.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (data.status === "1") {
        setProductName(data.result[0].product_name);
        setorder_title(data.result[0].order_title);
        setcomplain_dealer_review(data.result[0].complain_dealer_review);
        setcomplain_issued_quantity(data.result[0].complain_issued_quantity);
        setcomplain_supplied_quantity(
          data.result[0].complain_supplied_quantity
        );
        setcomplain_nature_of_issue(data.result[0].complain_nature_of_issue);
        setcomplain_issue_video(data.result[0].complain_issue_video);
        setcomplain_issue_image(data.result[0].complain_issue_image);
        
        // Set initial values for form fields
        setQuantity(data.result[0].complain_issued_quantity);
        setTitle(data.result[0].complain_nature_of_issue);
        setMessage(data.result[0].complain_dealer_review);
      } else {
        setProductName([]);
        setorder_title([]);
        setcomplain_dealer_review([]);
        setcomplain_issued_quantity([]);
        setcomplain_supplied_quantity([]);
        setcomplain_nature_of_issue([]);
        setcomplain_issue_video([]);
        setcomplain_issue_image([]);
        toast.warning(data.error);
      }
    } catch {
      toast.error("Please Try Again Later.");
    }
  };

  const handleUpdateComplain = async () => {
    if (!dealer_id) return navigate("/Logout");

    const updatedTitle = title.trim() || complain_nature_of_issue;
    const updatedMessage = message.trim() || complain_dealer_review;
    const updatedQuantity = quantity || complain_issued_quantity;

    setTitle(updatedTitle);
    setMessage(updatedMessage);
    setQuantity(updatedQuantity);

    if (!updatedTitle.trim() || !updatedMessage.trim() || !updatedQuantity) {
      toast.warning("Title, message, and issue quantity are required.");
      return setShow(true);
    }

    if (updatedQuantity > complain_supplied_quantity) {
      toast.warning(
        "Issued quantity cannot be greater than supplied quantity."
      );
      return setShow(true);
    }

    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("complain_id", oid);
    formData.append("complain_issued_quantity", updatedQuantity);
    formData.append("complain_nature_of_issue", updatedTitle);
    formData.append("complain_dealer_review", updatedMessage);
    if (image) formData.append("complain_issue_image", image);
    if (video) formData.append("complain_issue_video", video);

    try {
      const response = await axios.post(
        `${server_url}update_complain.php`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === "1") {
        navigate("/Complain");
      } else {
        setShow(true);
        toast.warning(response.data.error || "Please try again later.");
      }
    } catch {
      setShow(true);
      toast.error("Failed to update complaint. Please try again.");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="sticky-header">
        <Header />
      </div>

      <div className="update-complain-content">
        <div className="complain-container">
          <div className="complain-card">
            <div className="complain-card-header">
              <h1>Update Complaint</h1>
            </div>

            <div className="complain-form-container">
              <div className="complain-form-grid">
                {/* Order Information */}
                <div className="input-group">
                  <label>Order Information</label>
                  <input
                    type="text"
                    value={order_title}
                    readOnly
                    className="form-input"
                    style={{borderRadius:"12px"}}
                  />
                </div>

                {/* Product Information */}
                <div className="input-group">
                  <label>Product Name</label>
                  <input
                    type="text"
                    value={product_name}
                    readOnly
                    className="form-input"
                    style={{borderRadius:"12px"}}
                  />
                </div>

                {/* Quantity Input */}
                <div className="input-group">
                  <label>
                    Issue Quantity (Max: {complain_supplied_quantity || "N/A"})
                  </label>
                  <input
                    type="number"
                    value={quantity}
                    onChange={(e) => {
                      const enteredQty = parseInt(e.target.value, 10) || 1;
                      const maxQty = complain_supplied_quantity || 1;

                      if (enteredQty > maxQty) {
                        toast.warning(`Issue Quantity cannot exceed ${maxQty}`);
                        setQuantity(maxQty);
                      } else {
                        setQuantity(enteredQty);
                      }
                    }}
                    min="1"
                    max={complain_supplied_quantity || "1"}
                    className="form-input"
                    style={{borderRadius:"12px"}}
                  />
                </div>

                {/* Title Input */}
                <div className="input-group ">
                  <label>Complaint Title</label>
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Enter complaint title"
                    className="form-input"
                    style={{borderRadius:"12px"}}
                  />
                </div>

                {/* Message Textarea */}
                <div className="input-group full-width">
                  <label>Detailed Message</label>
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Describe your complaint in detail"
                    className="form-textarea"
                    rows="4"
                    style={{borderRadius:"12px"}}
                  />
                </div>

                {/* Image Upload */}
                <div className="input-group ">
                  <label>Update Image</label>
                  <div className="file-upload">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setImage(e.target.files[0])}
                      className="file-input"
                      style={{borderRadius:"12px"}}
                    />
                    <div className="file-hint">PNG, JPG, JPEG (Max 5MB)</div>
                  </div>
                  {complain_issue_image && (
                    <div className="media-preview" style={{borderRadius:"12px"}}>
                      <p className="preview-label">Current Image:</p>
                      <img
                        alt="issue"
                        src={complain_issue_image}
                        className="preview-image"
                      />
                    </div>
                  )}
                </div>

                {/* Video Upload */}
                <div className="input-group ">
                  <label>Update Video</label>
                  <div className="file-upload" >
                    <input
                      type="file"
                      accept="video/*"
                      onChange={(e) => setVideo(e.target.files[0])}
                      className="file-input"
                      style={{borderRadius:"12px"}}
                    />
                    <div className="file-hint">MP4, MOV (Max 20MB)</div>
                  </div>
                  {complain_issue_video && (
                    <div className="media-preview" style={{borderRadius:"12px"}}>
                      <p className="preview-label">Current Video:</p>
                      <iframe
                        title="issue"
                        src={complain_issue_video}
                        className="preview-video"
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Submit Button */}
              <div className="button-container">
                {!show ? (
                  <div className="loading-state">
                    <div className="spinner"></div>
                    <p>Updating your complaint...</p>
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      setShow(false);
                      handleUpdateComplain();
                    }}
                    className="submit-button"
                  >
                    Update Complaint
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        .page-wrapper {
          min-height: 100vh;
          background: #ffffff;
          display: flex;
          flex-direction: column;
        }

        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          width: 100%;
        }

        .update-complain-content {
          flex: 1;
          padding: 20px 15px;
          min-height: calc(100vh - 80px);
          margin-bottom: ${isMobile ? '70px' : '0'};
        }

        .complain-container {
          max-width: 900px;
          margin: 0 auto;
          width: 100%;
        }

        .complain-card {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid #e5e5e5;
          overflow: hidden;
        }

        .complain-card-header {
          padding: 30px 25px 20px;
          border-bottom: 1px solid #e5e5e5;
          background: #f8f9fa;
        }

        .complain-card-header h1 {
          color: #000000;
          font-size: 24px;
          font-weight: 600;
          margin: 0 0 8px 0;
          text-align: center;
        }

        .complain-card-header p {
          color: #666666;
          font-size: 14px;
          margin: 0;
          line-height: 1.5;
          text-align: center;
        }

        .complain-form-container {
          padding: 25px;
        }

        .complain-form-grid {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 30px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
        }

        .input-group.full-width {
          width: 100%;
        }

        .input-group label {
          color: #000000;
          font-weight: 600;
          margin-bottom: 10px;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .form-input,
        .form-textarea,
        .file-input {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 10px;
          padding: 14px 16px;
          color: #000000;
          font-size: 15px;
          transition: all 0.3s ease;
          font-family: inherit;
          width: 100%;
          box-sizing: border-box;
        }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #db4437;
          box-shadow: 0 0 0 3px rgba(219, 68, 55, 0.1);
        }

        .form-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          background: #f8f9fa;
        }

        .form-textarea {
          resize: vertical;
          min-height: 120px;
        }

        .file-upload {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .file-input {
          cursor: pointer;
          padding: 12px;
        }

        .file-input::-webkit-file-upload-button {
          background: #000000;
          border: none;
          color: #ffffff;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          margin-right: 12px;
          font-weight: 500;
          transition: background 0.3s ease;
        }

        .file-input::-webkit-file-upload-button:hover {
          background: #333333;
        }

        .file-hint {
          color: #666666;
          font-size: 12px;
          font-style: italic;
        }

        .media-preview {
          margin-top: 15px;
          padding: 15px;
          background: #f8f9fa;
          border-radius: 8px;
          border: 1px solid #e5e5e5;
        }

        .preview-label {
          color: #000000;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .preview-image {
          max-width: 100%;
          max-height: 200px;
          border-radius: 8px;
          border: 1px solid #e5e5e5;
        }

        .preview-video {
          width: 100%;
          height: 200px;
          border-radius: 8px;
          border: 1px solid #e5e5e5;
        }

        .button-container {
          width: 100%;
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid #e5e5e5;
        }

        .submit-button {
          background: #000000;
          color: white;
          border: none;
          padding: 16px 40px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          max-width: 300px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .submit-button:hover {
          background: #db4437;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(219, 68, 55, 0.2);
        }

        .submit-button:active {
          transform: translateY(0);
        }

        .loading-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
          color: #000000;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #f0f0f0;
          border-left: 4px solid #db4437;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Desktop Styles */
        @media (min-width: 768px) {
          .update-complain-content {
            padding: 30px 20px;
          }

          .complain-card-header {
            padding: 40px 50px 30px;
          }

          .complain-card-header h1 {
            font-size: 32px;
            text-align: left;
          }

          .complain-card-header p {
            font-size: 16px;
            text-align: left;
          }

          .complain-form-container {
            padding: 50px;
          }

          .complain-form-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 40px;
          }

          .input-group.full-width {
            grid-column: 1 / -1;
          }

          .submit-button {
            width: auto;
            min-width: 220px;
            padding: 16px 50px;
          }

          .preview-image {
            max-width: 400px;
          }

          .preview-video {
            width: 400px;
          }
        }

        /* Large Desktop Styles */
        @media (min-width: 1024px) {
          .complain-container {
            max-width: 900px;
          }
        }

        /* Mobile Optimizations */
        @media (max-width: 767px) {
          .complain-card {
            margin-top: 70px;
            border-radius: 12px;
          }

          .complain-card-header {
            padding: 25px 20px 15px;
          }

          .complain-form-container {
            padding: 20px;
          }

          .complain-form-grid {
            gap: 15px;
            margin-bottom: 25px;
          }

          .form-input,
          .form-textarea,
          .file-input {
            padding: 12px 14px;
            font-size: 14px;
          }

          .submit-button {
            padding: 14px 30px;
            font-size: 15px;
          }

          /* Touch optimizations for mobile */
          @media (hover: none) and (pointer: coarse) {
            .submit-button:hover {
              transform: none;
            }
          }
        }

        /* Very small screens */
        @media (max-width: 360px) {
          .update-complain-content {
            padding: 15px 10px;
          }

          .complain-card-header {
            padding: 20px 15px 12px;
          }

          .complain-card-header h1 {
            font-size: 20px;
          }

          .complain-form-container {
            padding: 15px;
          }

          .complain-form-grid {
            gap: 12px;
          }
        }
      `}</style>
    </div>
  );
}

export default UpdateComplain;